var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "title-content" },
    [
      _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._t("content", [
        _vm.content ? _c("span", [_vm._v(_vm._s(_vm.content))]) : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }